/**
 * Error codes for muted alerts
 *
 * Each map to the filename of svg illustation to show inside alert.
 */
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["NO_DATA"] = "no-data";
    ErrorCode["TIMED_OUT"] = "timed-out";
    ErrorCode["NOT_AUTHORIZED"] = "no-permissions";
    ErrorCode["GLOBAL_SEARCH"] = "muted-gloabl-alert-search";
    ErrorCode["GLOBAL_ANSWER"] = "muted-gloabl-alert-answer";
    ErrorCode["GLOBAL_DATA"] = "muted-gloabl-alert-data";
    ErrorCode["GLOBAL_IMPORT_SPOTAPPS"] = "muted-gloabl-alert-import-spotapps";
    ErrorCode["GLOBAL_EXPORT_SPOTAPPS"] = "muted-gloabl-alert-export-spotapps";
    ErrorCode["GLOBAL_FAVORITE"] = "muted-gloabl-alert-favorite";
    ErrorCode["GLOBAL_GENERAL_WARNING"] = "muted-gloabl-alert-general-warning";
    ErrorCode["GLOBAL_PINBOARD"] = "muted-gloabl-alert-pinboard";
    ErrorCode["GLOBAL_SPOTIQ"] = "muted-gloabl-alert-spotiq";
    ErrorCode["GLOBAL_TAG"] = "muted-gloabl-alert-tag";
    ErrorCode["GLOBAL_TRASH"] = "muted-gloabl-alert-trash";
    ErrorCode["GLOBAL_SUCCESS"] = "muted-global-alert-success";
    ErrorCode["LOCAL_GENERAL_WARNING"] = "muted-local-alert-general-warning";
    ErrorCode["LOCAL_GROUP"] = "muted-local-alert-group";
    ErrorCode["LOCAL_PERMISSION"] = "muted-local-alert-permission";
    ErrorCode["LOCAL_SPOTIQ"] = "muted-local-alert-spotiq";
    ErrorCode["LOCAL_SUCCESS"] = "muted-local-alert-success";
    ErrorCode["LOCAL_TIME_OUT"] = "muted-local-alert-time-out";
    ErrorCode["LOCAL_VISUALIZATION"] = "muted-local-alert-visualization";
    ErrorCode["LOCAL_GENERIC_NOT_FOUND"] = "muted-local-alert-generic-not-found";
    ErrorCode["STYLING_PANEL_INFO"] = "muted-local-alert-styling-panel";
})(ErrorCode || (ErrorCode = {}));
// If error code is not provided, show this svg illustration.
// Exclamation mark with some other elements.
export const GLOBAL_MUTED_ALERT_DEFAULT_ILLUSTRATION = ErrorCode.GLOBAL_GENERAL_WARNING;
// Exclamation mark
export const LOCAL_MUTED_ALERT_DEFAULT_ILLUSTRATION = ErrorCode.LOCAL_GENERAL_WARNING;
// Aria label for close button in banner and toast alerts
export const CLOSE_BTN_ARIA_LABEL = 'Close Alert';
/**
 * Delay to hide the toast alert
 *
 * Note: This is tied to animation duration in toast-alert.scss
 * $rd-animation--toast-short (4.8s)
 */
export const TOAST_HIDE_DELAY_MS = 4800;
//# sourceMappingURL=alert-constants.js.map